<div class="flip-clock-container" *ngIf="data" role="region" tabindex="-1" [attr.aria-label]="ariaLabel">
    <div class="clock">
        <!-- Use picture for easy media query support -->
        <finder-picture *ngIf="media?.plate" class="plate" [picture]="media?.plate"></finder-picture>

        <!-- Mobile Lotties: Intro and Outro -->
        <ng-container *ngIf="isMobile; else desktopLotties">
            @defer {
                <finder-lottie class="lottie-mobile layer"
                    [@fade]="data.outro ? introState : ''"
                    [data]="data.intro?.mobile">
                </finder-lottie>
            }
            @defer {
                <finder-lottie class="lottie-mobile outro layer"
                    *ngIf="data.outro"
                    [@fade]="outroState"
                    [data]="data.outro?.mobile">
                </finder-lottie>
            }
        </ng-container>

        <!-- Desktop Lotties: Intro and Outro -->
        <ng-template #desktopLotties>
            @defer {
                <finder-lottie class="lottie-desktop layer"
                    [@fade]="data.outro ? introState : ''"
                    [data]="data.intro?.desktop">
                </finder-lottie>
            }
            @defer {
                <finder-lottie class="lottie-desktop outro layer"
                    *ngIf="data.outro"
                    [@fade]="outroState"
                    [data]="data.outro?.desktop">
                </finder-lottie>
            }

        </ng-template>

        <ng-container *ngTemplateOutlet="endState ? endAnimation : countDown"></ng-container>
        <div class="bottom-content flex" [ngClass]="{'logo': media?.bottomImage}">
            <div class="message flex">
                <img *ngIf="media?.bottomImage" class="bottomImage" [src]="media?.bottomImage?.desktop" [alt]="media?.bottomImage?.alt"/>
                <span class="text" [ngClass]="{'lacd': isLACD}">{{copy?.text}}</span>
            </div>
        </div>
    </div>
</div>

<ng-template #countDown>
    <div class="flip-clock layer flex" [@fade]="introState">
        <finder-component-header *ngIf="data.headerData"
            [ngClass]="{'no-subtitle': !data.headerData?.subtitle}"
            class="countdown-message"
            [data]="data.headerData">
        </finder-component-header>
        <!-- When the original countdown ends - Remove the clock and start the 3 seconds countdown -->
        <finder-countdown-flip-clock *ngIf="!secondClock"
            [data]="data.config"
            (flipUpdate)="onUpdate($event)"
            (flipEnded)="onEnded($event)">
        </finder-countdown-flip-clock>
        <finder-countdown-flip-clock *ngIf="secondClock"
            [data]="data.config"
            (flipUpdate)="onUpdate($event)"
            (flipEnded)="onEnded($event)">
        </finder-countdown-flip-clock>
    </div>
</ng-template>

<ng-template #endAnimation>
    <finder-picture *ngIf="media?.transition" class="transition layer" [picture]="media?.transition"></finder-picture>
    <div class="end-state-message">
        <span class="sub-header" [innerHTML]="copy?.title | safeHtml"></span>
        <h2 class="header" [innerHTML]="copy?.subtitle | safeHtml"></h2>
        <div class="mobile-header" *ngIf="mobileCopy?.length">
            <span>{{mobileCopy[0]}}</span>
            <span>{{copy?.mobileHeader}}</span>
            <span>{{mobileCopy[1]}}</span>
        </div>
        <span class="copy" [innerHTML]="copy?.description | safeHtml"></span>
    </div>
</ng-template>
